import { Box } from '@mui/material';
import type {
  AtterbergContext,
  AtterbergGeneral,
  AtterbergDetail,
} from '../../../types/atterberg';
import { AtterbergSummaryTable } from './AtterbergSummaryTable';
import { FlowCurveChart } from './charts/FlowCurveChart';
import { PlasticityChart } from './charts/PlasticityChart';

interface Props {
  context: AtterbergContext;
  general: AtterbergGeneral;
  llTrials: AtterbergDetail[];
  plTrials: AtterbergDetail[];
  retestLLTrials?: AtterbergDetail[];
}

export const AtterbergAnalysis = ({ context, general, llTrials, plTrials, retestLLTrials }: Props) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <AtterbergSummaryTable
      context={context} general={general} llTrials={llTrials} plTrials={plTrials}
      retestLLTrials={retestLLTrials}
    />
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
      <FlowCurveChart general={general} llTrials={llTrials} plTrials={plTrials} />
      <PlasticityChart general={general} llTrials={llTrials} plTrials={plTrials} />
    </Box>
  </Box>
);
